export default __webpack_public_path__ + "static/media/moon.8c406289.svg";